// extracted by mini-css-extract-plugin
export var numberInputContainer = "_79-0";
export var startPickingButton = "_79-1";